import React, { Dispatch, SetStateAction } from 'react';
import { SUGGESTION_AVAILABLE } from '../constants';

export default function buildModalButtons(
  modalType: string | undefined,
  setShowAddressVerification: Dispatch<SetStateAction<boolean>>,
  handleSubmitClick: (addressSelected: string) => void,
  addressSelected: string,
) {
  if (modalType === SUGGESTION_AVAILABLE) {
    return (
      <button
        type="button"
        onClick={() => {
          setShowAddressVerification(false);
          handleSubmitClick(addressSelected);
        }}
        className="av__submit"
      >
        USE THIS ADDRESS
      </button>
    );
  }

  return (
    <>
      <button
        className="av__submit"
        type="button"
        onClick={() => {
          setShowAddressVerification(false);
        }}
      >
        EDIT ADDRESS
      </button>
      <button
        type="button"
        onClick={() => {
          setShowAddressVerification(false);
          handleSubmitClick(addressSelected);
        }}
        className="av__edit-button av__edit-button--submit"
      >
        USE THIS ADDRESS
      </button>
    </>
  );
}
